import Vue from 'vue'
import Store from './vuex/store.js'
import VueLocalStorage from 'vue-localstorage'
import VueSessionStorage from 'vue-sessionstorage'
import Router from './router'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
//import VueLazyload from 'vue-lazyload'
import Utilities from './utilities'
import VueCookies from 'vue-cookies'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';


/*
Vue.component('v-style', {
    render: function (createElement) {
        return createElement('style', this.$slots.default)
    }
})
*/

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPlane, faBed, faBus, faSave, faArrowRight, faHospitalSymbol, faQuestion, faHeart, faPen, faGlobe, faPencilAlt, faEnvelope, faEye, faDownload, faClone, faTimes, faPlus, faMinus, faCheck, faClipboardList, faTrash, faRetweet, faSearch} from '@fortawesome/free-solid-svg-icons'
library.add(faPlane, faBed, faBus, faSave, faArrowRight, faHospitalSymbol, faQuestion, faHeart, faPen, faGlobe, faPencilAlt, faEnvelope, faEye, faDownload, faClone, faTimes, faPlus, faMinus, faCheck, faClipboardList, faTrash, faRetweet, faSearch)
Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false
window.eventBus = new Vue() //catch events from api.js

Vue.use(VueCookies)
Vue.$cookies.config('30d')
Vue.use(VueLocalStorage)
Vue.use(VueSessionStorage)
//Vue.use(VueLazyload, {})
Vue.use(BootstrapVue)//, {breakpoints: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']})
Vue.mixin(Utilities)
Vue.use(VueVirtualScroller)
Vue.use(VueToast)
Vue.use(require('vue-moment'));

// Prevent Bootstrap dialog from blocking focusin
// fix per bug bootstrap e tinymce by Peppe (le inputs nella modale per editing dei links non erano usabili)
document.addEventListener('focusin', function(e) {
    if (e.target.closest(".tox") !== null) {
        e.stopImmediatePropagation();
    }
})

/* saves the WHOLE state in localstorage after every mutation
Store.subscribe((mutation, state) => {
    Vue.localStorage.set(process.env.VUE_APP_STORE_KEY, JSON.stringify(state))
})
*/

// saves ONLY THE TOKEN from state in localstorage after every mutation
Store.subscribe((mutation, state) => {
    if(mutation.type !== 'set_token') return
    let new_state = {
        token: state.token
    }
    Vue.localStorage.set(process.env.VUE_APP_STORE_KEY, JSON.stringify(new_state))
})

Vue.config.performance = ( process.env.VUE_APP_MODE == 'development' ? true : false)

new Vue({
    router: Router,
    el: '#app',
    store: Store,
    mixins: [
        Utilities,
        //Config
    ],
    render: h => h(App),
    beforeCreate () {
        //Vue.prototype.$config = {}
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate() {
    },
    update () {
    },
    beforeDestroy () {
    },
    destroyed () {
    }
})